<template>
    <div>
        <v-col class="pa-0" cols="12" :style="offset">
            <template>
                <v-card
                    class="mx-auto"
                    tile
                    :style="offset"  
                    elevation="0"
                    :color="cardColor"    
                >
                    <v-list-item class="comment-content">
                        <v-avatar :color="avatarColor" class="mr-3 avatar" size="30" left>
                            <v-icon dark>mdi-account</v-icon>
                        </v-avatar>
                        <v-list-item-content>
                            <v-list-item-title class="font-weight-bold mb-1">{{ item.user }}</v-list-item-title>
                            <div class="overline mb-4">{{ item.created_at }}</div>
                            <div class="text--primary comment-text" v-html="item.comment" v-viewer="voptions"></div>
                        </v-list-item-content>
                    </v-list-item>
                    <v-card-actions class="comment-actions py-0">
                        <v-btn color="primary" text tile small elevation="0" @click.prevent="replyComment(item.id, item.type)">Reply</v-btn>
                    </v-card-actions>
                </v-card>
                <v-divider></v-divider>
            </template>
        </v-col>
        <template v-if="item.children">
            <Comment
                v-for="record in item.children"
                :key="record.id"
                :item="record"
                :depth="depth + 1"
                @set-parent="replyComment(item.id, record.type)"
                @born="handleBorn()" />
        </template>
    </div>
</template>

<script>
const COLORS = [
    'white',
    'grey lighten-5',
    'grey lighten-4',
    'grey lighten-3',
    'grey lighten-2',
];

export default {
    // MUST give a name in recursive components
    // https://vuejs.org/v2/guide/components-edge-cases.html#Recursive-Components
    name: 'Comment',

    props: {
        item: {type: Object, required: true},
        depth: {type: Number, default: 0},
    },

    data() {
        return {
            childrenCount: 0,
            voptions: { "inline": false, "button": true, "navbar": false, "title": false, "toolbar": true, "tooltip": false, "movable": false, "zoomable": true, "rotatable": false, "scalable": false, "transition": false, "fullscreen": false, "keyboard": false, "url": "data-source" }
        };
    },

    computed: {
        direct() {
            if (Array.isArray(this.item.children)) {
                return this.item.children.length;
            }

            return 0;
        },

        offset() {
            return {
                'padding-left': (this.depth * 20) + 'px'
            };
        },

        cardColor() {
            return COLORS[this.depth % COLORS.length]
        },

        avatarColor() {
            if(this.item.user_type == 'C')
                return 'red'
            else
                return '#1565c0'
        }
    },

    filters: {
        short_hand (name) {
            // You can put your logic here...
            let words = name.split(" ")
            let short_hand = words[0][0] + words[words.length-1][0]
            return short_hand // <-- The return value as Per logic
        }
    },

    mounted() {
        this.$emit('born');
    },

    methods: {
        handleBorn() {
            this.childrenCount++;
            this.$emit('born');
        },
        replyComment(parent, type) {
            this.$emit('set-parent', parent, type)
        },  
    },
};
</script>

<style lang="sass" scoped>
.comment-actions
    padding-left: 50px

.comment-content 
    align-items: flex-start

.avatar 
    margin-top: 15px
</style>